var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.25H14.75V4C14.75 3.04 13.96 2.25 13 2.25H11C10.04 2.25 9.25 3.04 9.25 4V4.25H9C6.93 4.25 5.25 5.93 5.25 8V18C5.25 20.07 6.93 21.75 9 21.75H15C17.07 21.75 18.75 20.07 18.75 18V8C18.75 5.93 17.07 4.25 15 4.25ZM10.75 4C10.75 3.86 10.86 3.75 11 3.75H13C13.14 3.75 13.25 3.86 13.25 4V5.25H10.75V4ZM17.25 18C17.25 19.24 16.24 20.25 15 20.25H9C7.76 20.25 6.75 19.24 6.75 18V8C6.75 6.76 7.76 5.75 9 5.75H9.25V6C9.25 6.41 9.59 6.75 10 6.75H14C14.41 6.75 14.75 6.41 14.75 6V5.75H15C16.24 5.75 17.25 6.76 17.25 8V18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.75C13.52 13.75 14.75 12.52 14.75 11C14.75 9.48 13.52 8.25 12 8.25C10.48 8.25 9.25 9.48 9.25 11C9.25 12.52 10.48 13.75 12 13.75ZM12 9.75C12.69 9.75 13.25 10.31 13.25 11C13.25 11.69 12.69 12.25 12 12.25C11.31 12.25 10.75 11.69 10.75 11C10.75 10.31 11.31 9.75 12 9.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.22 15.77C14.75 14.83 13.81 14.25 12.76 14.25H11.23C10.18 14.25 9.24 14.83 8.77 15.77L8.32 16.66C8.13 17.03 8.28 17.48 8.66 17.67C9.03 17.86 9.48 17.7 9.67 17.33L10.12 16.44C10.33 16.01 10.76 15.75 11.24 15.75H12.77C13.25 15.75 13.68 16.01 13.89 16.44L14.34 17.33C14.47 17.59 14.74 17.74 15.01 17.74C15.12 17.74 15.24 17.71 15.34 17.66C15.71 17.47 15.86 17.02 15.68 16.65L15.23 15.76L15.22 15.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.1df9440d5b62144a01a92da5c1fde060.svg";
export { ForwardRef as ReactComponent };